import { render, staticRenderFns } from "./SatinalmaIslemiButon.vue?vue&type=template&id=921f7520"
import script from "./SatinalmaIslemiButon.vue?vue&type=script&lang=js"
export * from "./SatinalmaIslemiButon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports